import React from "react";
import styled from "styled-components";
import { regex_obj } from "../../Constant";

const CustomInputStyle = styled.input`
  height: ${(props) => (props.height ? props.height : "40px;")}
  border-radius: ${(props) => (props.height ? '4px !important' : "5px;")};
  padding: ${(props) => (props.height ? '4px 12px' : "")};
  border: solid 1px #57585a;
  color: #000;
  margin: 0;
  resize: none;
  font-size: 13px;
  box-shadow: none;
  width: 100%;
  background-color: ${(props) => (props.readOnly ? "#e9ecef;" : "white")};
  ${(props) =>
    props.readOnly &&
    `
  &.form-conrol:focus{
    background-color: #e9ecef;
    border:none;
  }
  `}
`;

const CustomInput = ({
  className,
  onChange,
  value,
  placeholder,
  readOnly = false,
  regex = regex_obj.common,
  maxLength = 40,
  showError = true,
  disabled = false,
  height
}) => {
  const [error, setError] = React.useState(false);
  return (
    <div className={`${className ? className : ""}`}>
      <CustomInputStyle
        type="text"
        disabled={disabled}
        className={`form-control ${showError && value?.length > 0 && (error ? "is-invalid" : "is-valid")
          }`}
        aria-label="Small"
        aria-describedby="inputGroup-sizing-sm"
        placeholder={placeholder}
        onChange={(e) => {
          if (regex.test(e.target.value)) {
            setError(false);

          } else {
            setError(true);
          }
          onChange(e);
        }}
        value={value}
        readOnly={readOnly}
        onClick={(e) => onChange(e)}
        regex={regex}
        required
        maxLength={maxLength}
        height={height}
      />
    </div>
  );
};

export default CustomInput;
